@let isArabic = isArabic$ | async;

<button type="button" class="btn btn-outline-primary subscribe-button" (click)="open()">
  <i class="bi bi-bell-fill"></i>
  {{ 'SAVED_SEARCH.notify' | translate }}
</button>
@if (feedback()) {
  <p role="status" class="feedback">{{ feedback() | translate }}</p>
}
<dialog
  #dialog
  class="saved-dialog"
  [ngClass]="{ 'rtl-mode': isArabic, 'ltr-mode': !isArabic }"
  [attr.aria-labelledby]="titleId"
  (cancel)="cancel($event)"
  [attr.aria-busy]="pending()"
>
  <h2 [id]="titleId" class="d-flex justify-content-center text-primary">
    <i class="bi bi-bell-fill mx-2 colo"></i>
    {{ 'SAVED_SEARCH.notify' | translate }}
  </h2>
  @if (request(); as snapshot) {
    <p>{{ 'SAVED_SEARCH.description' | translate }}</p>
    <h3>{{ 'SAVED_SEARCH.yourSearch' | translate }}:</h3>
    <ul class="criteria-list">
      @for (line of summary.format(snapshot.criteria, snapshot.domain); track $index) {
        <li>{{ line }}</li>
      }
    </ul>
  }
  @if (error()) {
    <p role="alert" class="feedback error">{{ error() | translate }}</p>
  }
  @if (pending()) {
    <p role="status">
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      {{ 'SAVED_SEARCH.saving' | translate }}
    </p>
  }
  <div class="saved-actions">
    <button class="btn btn-secondary" type="button" [disabled]="pending()" (click)="close()">
      {{ 'SAVED_SEARCH.cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" [disabled]="pending()" (click)="confirm()">
      <i class="bi bi-bell-fill"></i>
      {{ 'SAVED_SEARCH.confirm' | translate }}
    </button>
  </div>
</dialog>
